'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { spacing } from '../../mixins/spacing.js';
import { Flex } from '../Flex/Flex.js';
import { Spinner } from '../Spinner/Spinner.js';
import { Text } from '../Text/Text.js';

const LoaderContainer = styled.div.withConfig({
  componentId: "sc-1nsk30u-0"
})(["display:flex;flex-direction:column;justify-content:center;height:inherit;"]);
const StyledLoadingText = styled(Text).withConfig({
  componentId: "sc-1nsk30u-1"
})(["text-align:center;padding:", ";"], spacing(8));
const DrawerLoader = /*#__PURE__*/withTitan(({
  loadingText,
  testId = 'drawerLoader'
}) => {
  return jsx(LoaderContainer, {
    "data-test-id": testId,
    children: jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      children: [jsx(Flex, {
        spaceAfter: 4,
        children: jsx(Spinner, {
          size: 48,
          testId: `${testId}Spinner`
        })
      }), loadingText && jsx(StyledLoadingText, {
        color: "grey70",
        "data-test-id": `${testId}Text`,
        type: "labelSmall",
        children: loadingText
      })]
    })
  });
}, {
  name: 'DrawerLoader'
});

export { DrawerLoader };
//# sourceMappingURL=DrawerLoader.js.map
